import ClassSchedule from '../components/ClassSchedule';
import SEO from '../components/SEO';
import { MEDIA_SLOTS } from '../lib/mediaTruth';
import { ScheduleNavigation, ScheduleHero, ScheduleMedia, ClassLedger } from './SchedulePresentation';
import { TourClosing } from '../components/TourJourney';

const cardioClasses = [
  {
    name: 'Pedal and Pump',
    description: 'Ignite your energy with 30 minutes of heart-pounding spin, followed by a weightlifting blast!',
  },
  {
    name: 'Battle in the Saddle',
    description: 'Dance under party lights as artists battle—grab your number at the front desk at 9am and let the showdown begin!',
  },
  {
    name: 'The ZONE',
    description: 'Get your Monday started with a ride that will get you “in the ZONE”! This class will challenge you with intervals and drills to awesome music. Get a jumpstart to your week and feel energized!',
  },
  {
    name: 'Zumba',
    description: 'Dance to the rhythm of fun! Join our upbeat Zumba classes featuring percussion beats for an energizing workout that’ll leave you feeling alive and invigorated. Let the music move you!',
  },
  {
    name: 'Cardio at the Barre',
    description: 'Spin meets barre for a unique, heart-pounding sculpting fusion.',
  },
  {
    name: 'Kickboxing',
    description: 'A high-energy martial arts-inspired workout combining punches, kicks, and cardio for an intense full-body burn and stress relief.',
  },
];

const CardioPage = () => (
  <main className="dv-class-pages" data-testid="cardio-page">
    <SEO
      title="Cardio Classes"
      description="Explore Delta Valley Health Club cardio classes, including spin, Zumba, barre, and kickboxing, and view the live Group Exercise schedule."
      keywords="Delta Valley cardio classes, Brentwood spin classes, Brentwood Zumba, Brentwood kickboxing, group exercise schedule"
    />
    <ScheduleHero title="Cardio" scheduleId="cardio-schedule" facts={['Spin, Zumba, barre & kickboxing', 'Group Exercise schedule', 'Included with membership']} media={<ScheduleMedia media={MEDIA_SLOTS.cardioHero} caption="Cardio floor" />}>
      <p className="dv-size-lede text-lg leading-relaxed">Experience a dynamic fusion of cardio classes—from heart-pounding spin sessions to empowering kickboxing. Elevate your workout diversity under one membership.</p>
    </ScheduleHero>
    <ScheduleNavigation current="/schedule/cardio" />
    <section className="dv-class-pages__catalog" aria-labelledby="cardio-classes-title">
      <div className="dv-class-pages__catalog-intro">
        <p className="dv-class-pages__eyebrow text-sm font-bold uppercase tracking-[0.2em]">Included with membership</p>
        <h2 id="cardio-classes-title" className="dv-size-heading text-3xl font-bold uppercase leading-tight md:text-4xl">One Membership,<br />Many Options</h2>
        <ScheduleMedia media={MEDIA_SLOTS.cardioGroupClass} caption="Group barbell class" />
      </div>
      <ClassLedger classes={cardioClasses.map(({ name, description }) => [name, description])} />
    </section>
    <section className="dv-class-pages__schedule" id="cardio-schedule" aria-labelledby="cardio-schedule-title">
      <div className="dv-class-pages__schedule-heading">
        <div>
          <p className="dv-class-pages__eyebrow text-sm font-bold uppercase tracking-[0.2em]">Updated live</p>
          <h2 id="cardio-schedule-title" className="dv-size-heading text-3xl font-bold md:text-4xl">Cardio &amp; Group Exercise Schedule</h2>
          <p className="dv-size-body">This view opens on Cardio classes. Pick a day, switch programs, or narrow by time of day or instructor.</p>
        </div>
      </div>
      <ClassSchedule focus="cardio" categoryId="9" title="Delta Valley Health Club Cardio and Group Exercise weekly schedule" />
    </section>
    <TourClosing />
  </main>
);

export default CardioPage;
